/*
 * @Descripttion: 付款申请列表页State
 * @Author: 曹博
 * @Date: 2023-12-06 16:00:20
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-06 16:02:36
 */
import { ActionType, CustomAction } from '../../global'

export interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  dataSource: any[]
  isTableLoading?: boolean
  paginationOption: PaginationOption
  searchParam: any
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParamAction = (val: any): CustomAction<Action> => ({
  type: 'setSearchParamAction',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (
  val: PaginationOption,
): CustomAction<Action> => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

// 页面loading
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})
/*
 * @Descripttion: 付款申请列表页State
 * @Author: 曹博
 * @Date: 2023-12-06 16:00:20
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-06 16:02:36
 */
import { ActionType, CustomAction } from '../../global'

export interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  dataSource: any[]
  isTableLoading?: boolean
  paginationOption: PaginationOption
  searchParam: any
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParamAction = (val: any): CustomAction<Action> => ({
  type: 'setSearchParamAction',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (
  val: PaginationOption,
): CustomAction<Action> => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

// 页面loading
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})
